import React, { createContext, useState } from "react";

export type TLoadingContext = {
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
};

export const LoadingContext = createContext<TLoadingContext>(
  {} as TLoadingContext
);

const LoadingProvider = (props: any) => {
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <LoadingContext.Provider value={{ loading, setLoading }}>
      {props.children}
    </LoadingContext.Provider>
  );
};

export default LoadingProvider;
